import { render } from "./GroupManagement.vue?vue&type=template&id=108ed4d4&ts=true"
import script from "./GroupManagement.vue?vue&type=script&lang=ts"
export * from "./GroupManagement.vue?vue&type=script&lang=ts"

import "./GroupManagement.vue?vue&type=style&index=0&id=108ed4d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__